import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 获取会话申请列表
 */
export const getList = (params = {}) => {
    return postWithJson('/conversationArchive/applyList.np', params)
}

/**
 * 新增
 */
export const add = (params = {}) => {
    return postWithJson('/conversationArchive/add.np', params)
}

/**
 * 编辑
 */
export const mod = (params = {}) => {
    return postWithJson('/conversationArchive/mod.np', params)
}
